import type { JiraSprintState } from '@atlassian/jira-relay/src/__generated__/getSprintPropsQuery.graphql';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages.tsx';

export const hasValue = (text?: string | null) => typeof text === 'string' && text.length > 0;

/**
 * Given a GraphQL JiraSprintState value, this function returns its i18n label
 * @param state GraphQL JiraSprintState value, e.g. ACTIVE
 * @param formatMessage react-intl's formatMessage function
 * @returns {string} i18n label for the sprint state, e.g. "Active"
 */
export const getSprintState = (
	state: JiraSprintState,
	formatMessage: FormatMessage,
): string | undefined => {
	switch (state) {
		case 'ACTIVE':
			return formatMessage(messages.active);
		case 'FUTURE':
			return formatMessage(messages.future);
		case 'CLOSED':
			return formatMessage(messages.closed);
		default:
			return undefined;
	}
};
